import { FunctionComponent } from "react";
import { Flex } from "../../../../../../../components/layout";

interface INoKycEntriesProps {}

const NoKycEntries: FunctionComponent<INoKycEntriesProps> = () => {
  return (
    <Flex center>
      <h2>No KYC Entries to fill in</h2>
    </Flex>
  );
};

export default NoKycEntries;
